import React from 'react';
/**
 * withCategoryManagementVendorSegmentationProviders HOC Component
 * @param {JSX} WrappedComponent - Accepts a component and gives a Wrapped componets with Context Providers
 */

// Higher Order Component (HOC) that wraps a component with multiple providers
const withCategoryManagementVendorSegmentationProviders = WrappedComponent => {
	// Return a new component with added context providers
	return function CategoryManagementWrapper(props) {
		return (
			<>
				<WrappedComponent {...props} />
			</>
		);
	};
};

export default withCategoryManagementVendorSegmentationProviders;
